import React, { useMemo } from "react";
import { TableCell, TableRow, Typography } from "@material-ui/core";
import { createStyles, withStyles } from "@material-ui/core/styles";

import ChipField from "../components/fields/ChipField";
import { DateField } from "react-admin";
import EditButton from "../components/buttons/EditButton";
import SensorValueField from "../components/fields/SensorValueField";
import { compose } from "recompose";
import { get } from "lodash";
import { translate } from "react-admin";
import { useRowHighlightTracking } from "../components/utils/useRowHighlightTracking";

const styles = (theme) =>
  createStyles({
    modifySensor: {
      backgroundColor: "#1E90FF",
      // hover: {
      //   backgroundColor: "#00b5ff",
      // },
    },
  });

const ExpandedRow = ({ websocket, translate, classes, record }) => {
  const sensors = useMemo(
    () => get(record, "sensors", []).filter((s) => s.name !== s.code),
    [record]
  );
  const { sensor: highlightedSensorIds = [] } = useRowHighlightTracking();
  if (sensors.length === 0) {
    return (
      <TableRow>
        <TableCell padding="none" className={classes.rowCell} colSpan={2} />
        <TableCell padding="none" className={classes.rowCell} colSpan={6}>
          <Typography variant="body2">
            {translate("resources.device.no_sensors")}
          </Typography>
        </TableCell>
      </TableRow>
    );
  }
  return sensors.map((sensor) => (
    <TableRow
      key={get(sensor, "id")}
      // style={
      //   highlightedSensorIds.includes(sensor.id?.toString())
      //     ? { backgroundColor: "#1E90FF" }
      //     : {}
      // }
      className={
        highlightedSensorIds.includes(sensor.id?.toString())
          ? "modifySensor"
          : {}
      }
    >
      <TableCell padding="none" className={classes.rowCell} colSpan={2}>
        &nbsp;
      </TableCell>
      <TableCell padding="none" className={classes.rowCell}>
        {get(sensor, "id")}
      </TableCell>
      <TableCell padding="none" className={classes.rowCell}>
        <ChipField record={sensor} source="code" />
      </TableCell>
      <TableCell padding="none" className={classes.rowCell}>
        {get(sensor, "name")}
      </TableCell>
      <TableCell padding="none" className={classes.rowCell}>
        <SensorValueField websocket={websocket} record={sensor} />
      </TableCell>
      <TableCell padding="none" className={classes.rowCell}>
        <DateField record={sensor} source="modified" showTime />
      </TableCell>
      <TableCell padding="none" className={classes.rowCell}>
        <EditButton record={sensor} basePath="sensor" resource="sensor" />
      </TableCell>
    </TableRow>
  ));
};

export default compose(withStyles(styles), translate)(ExpandedRow);
